<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>
    <lib-slide-toggle
        [checked]="checked()"
        (checkedChange)="onToggleChange($event)"
        [isReadOnly]="isReadOnly()"
    ></lib-slide-toggle>
</article>
